import React from "react";
import styled from "styled-components";
import { Button } from "reactstrap";

export const FormHeader = styled.div`
  padding: 5px 0px;
  margin-top: 15px;
  flex: 1;
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  padding: 12px 0px;
  color: #0f9bf0;
  border-bottom: 4px solid #00aaff;
  width: 100%;
  text-transform: uppercase;
`;

export const FormHeaderError = styled.div`
  padding: 5px 0px;
  margin-top: 15px;
  flex: 1;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  padding: 12px 0px;
  color: #e5084a;
  border-bottom: 3px solid #e5084a;
  width: 100%;
  text-transform: uppercase;
`;

export const StyledLabel = styled.div`
  font-size: ${p => p.theme["font-size"]};
  font-weight: 600;
  color: ${p => p.theme.color} !important;
  line-height: 21px;
  letter-spacing: 0.3px;
  margin-top: 16px;
`;

export const StyledInput = styled.input`
  box-sizing: border-box;
  height: 40px;
  width: 100%;
  border: ${props => props.theme.dropDown["border"]};
  border-radius: ${props => props.theme.dropDown["border-radius"]};
  background-color: ${props => props.theme.white};
  padding: 0 14px;
  margin-top: 8px;
  outline: 0 !important;

  &.invalid {
    color: ${p => p.theme.errorColor};
    border: ${p => p.theme["error-border"]};
    background-color: ${p => p.theme.red};
  }
  &:disabled {
    color: ${p => p.theme['disabled-grey']};
    background-color: ${p => p.theme['backgroundDisabled']};
  }
`;

export const NotifWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  width: 100%;
  box-shadow: 0 0 1px 0 rgba(10, 31, 68, 0.1),
    0 8px 26px 0 rgba(10, 31, 68, 0.13);
  margin-bottom: 16px;
  padding: 16px;
`;

export const FormWrapper = styled.div`
  position: relative;
  z-index: 9999;

  box-shadow: 0 0 1px 0 rgba(10, 31, 68, 0.1),
    0 26px 26px 0 rgba(10, 31, 68, 0.12);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  width: 100%;
`;

export const FormBody = styled.div`
  padding: 15px 50px 0px 50px;
  display: flex;
  flex-direction: column;
  margin-bottom: 50px;
  width: 100%;

  @media (max-width: 475px) {
    padding-left: 15px;
    padding-right: 15px;
  }
`;

export const StyledP = styled.p`
  margin-top: 20px;
  margin-bottom: 0;
  font-size: 14px;
`;

export const SubmitButton = styled(Button)`
  width: 100%;
  margin-top: 30px;
  margin-bottom: 5px;
  background: #0f9bf0;
  color: white;
  min-height: 38px;
  font-size: 16px;
  font-weight: 700;
  border: 0;

  &:hover {
    background: #0892e5 !important;
    border: 0 !important;
    color: white !important;
  }

  &:active {
    background: #0584d7 !important;
    border: 0 !important;
    color: white !important;
  }

  &:disabled {
    border: 0;
    color: #444a56;
    opacity: 0.4;
  }
`;

export const SubmitDangerButton = styled(Button)`
  width: 100%;
  margin-top: 30px;
  margin-bottom: 5px;
  background: #e5084a;
  color: white;
  min-height: 38px;
  font-size: 16px;
  border: 0;

  &:hover {
    background: #c7053f !important;
    color: white !important;
    border: 0 !important;
  }
`;

export const PassWrapper = styled.div`
  position: relative;
`;

export const PassHideButton = styled.button`
  position: absolute;
  border: none;
  background-color: transparent;
  right: 4px;
  top: 13px;
`;

export const PassHideImg = styled.img``;
